import { render } from "./EditaRolForm.vue?vue&type=template&id=8b6d2158&scoped=true"
import script from "./EditaRolForm.vue?vue&type=script&lang=js"
export * from "./EditaRolForm.vue?vue&type=script&lang=js"

import "./EditaRolForm.vue?vue&type=style&index=0&id=8b6d2158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6d2158"]])

export default __exports__